/** Matches global scrollbar styling in main.css */
export const platformScrollbarSx = {
  scrollbarWidth: "thin",
  scrollbarColor: "rgba(0, 0, 0, 0.14) transparent",
  "&::-webkit-scrollbar": {
    width: "5px",
    height: "5px",
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "rgba(0, 0, 0, 0.14)",
    borderRadius: "999px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "rgba(0, 0, 0, 0.22)",
  },
} as const;
